import { GalleryImage } from 'models'
import { Label } from './types'

export const removeCroppingTool = (
  cropping: Label,
  index: number,
  images: GalleryImage[],
  setImages: (imgs: GalleryImage[]) => void
) => {
  const cloneImages = [...images]
  cloneImages[index] = {
    ...cloneImages[index],
    [cropping]: false,
    [`${cropping}Width`]: null,
    [`${cropping}X`]: null,
    [`${cropping}Y`]: null
  }
  setImages(cloneImages)
}
